// import mainBackground from '../images/backgroundImages/main_background.jpg';

export const TextStyle = {
  mainTitleDiv: {
    // width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    color: '#F72585',
  },
  mainTitleTxt: {
    fontSize: '35px',
    fontWeight: 'bold',
  },
  mainTitleTxtBorderBottom: {
    borderTop: '3px solid #F72585',
    width: '100px',
  },
  subTitleTxt1: {
    fontSize: '22px',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  subTitleTxt2: {
    fontSize: '20px',
    fontWeight: 'bold',
  },
  subTitleTxt3: {
    fontSize: '16px',
    fontWeight: 'bold',
  },
  normalTxt0: {
    fontSize: '22px',
  },
  normalTxt1: {
    fontSize: '16px',
  },
  normalTxt2: {
    fontSize: '14px',
  },
  normalTxt3: {
    fontSize: '12px',
  },
};

export const MainStyle = {
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    // eslint-disable-next-line max-len

  },
};

export const BackgroundImageStyle = {
  backgroundImageStyle: {
    display: 'fixed',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    top: '0px',
    width: '100%',
    height: window.innerHeight,
    backgroundImage: 'url(/images/main_background.jpg)',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  },
  contentDIvActive: {
    display: 'flex',
    width: '100%',
    height: window.innerHeight,
    flexDirection: 'colum',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgb(0, 0, 0, 0.5)',
    zIndex: 1,
    transition: '1s 0ms all linear',
  },
  contentDIvInactive: {
    display: 'flex',
    width: '100%',
    height: window.innerHeight,
    flexDirection: 'colum',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgb(181, 23, 158, 1)',
    zIndex: 1,
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '10px',
    marginLeft: '10px',
  },
  borderCol: {
    display: 'flex',
    flexDirection: 'column',
    width: '350px',
    border: 'solid 1px white',
    borderColor: 'white',
  },
  NameCol: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    marginTop: '10px',
    marginBottom: '10px',
  },
  professionCol: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    marginTop: '20px',
  },
  exploreButtonActive: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '20px',
    backgroundColor: '#B5179E',
    transition: '500ms 0ms all linear',
    width: '150px',
    height: '50px',
    border: 'solid 0px #B5179E',
  },
  exploreButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '20px',
    backgroundColor: 'rgba(181, 23, 158, 0.2)',
    width: '150px',
    height: '50px',
    border: 'solid 2px #B5179E',
  },
  exploreIcon: {
    fontSize: '20px',
    marginLeft: '15px',
  },
};

export const HeaderStyle = {
  headerContainer: {
    transition: '500ms 0ms all linear',
    backgroundColor: 'rgba(181, 23, 158, 0)',
    top: 0,
    position: 'fixed',
    width: '100%',
    // height: '50px',
    // borderBottom: '5px solid #F72585',
    zIndex: 2,
  },
  headerBrandStyle: {
    color: 'white',
    marginLeft: '20px',
  },
  toggleStyle: {
    color: '#F72585',
    backgroundColor: '#4CC9F0',
    marginRight: '20px',
    marginLeft: '20px',
  },
  eachInactiveLinkDiv: {
    color: 'white',
    marginLeft: '20px',
  },
  /*
  activeLinkDiv: {
    color: '#4CC9F0',
  },
  */
};

export const AboutMeStyle = {
  aboutMainDiv: {
    display: 'flex',
    width: '100%',
    // backgroundColor: '#4CC9F0',
  },
  aboutMeDiv: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '80px',
    padding: '20px',
  },
  eachAboutMeDiv: {
    // width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '70px',
  },
  aboutMeProfileDiv: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '20px',
  },
  profilePic: {
    width: '300px',
    height: '300px',
  },
  NameTitle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '10px',
    color: '#000000ba',
  },
  aboutMeDescriptionTxt: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: '10px',
    color: '#000000ba',
    width: '80%',
  },
  progressBarStyleDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  eachProgressDiv: {
    marginBottom: '10px',
    width: '70%',
  },
  progressBarTextDiv: {
    color: '#000000ba',
  },
  eachProgressBar: {
    height: '20px',
    // backgroundColor: '#F1FAEE',
    // color: 'black',
  },
  eachTechHeading: {
    color: '#000000ba',
  },
  eachTecCol: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  eachTechDiv: {
    border: '1px solid #B5179E',
    marginTop: '30px',
    width: '350px',
    height: '180px',
  },
  eachTechTitleDiv: {
    backgroundColor: '#B5179E',
    color: 'white',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  eachTechContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px',
  },
  eachTechImage: {
    width: '70px',
    height: '70px',
  },
};

export const ProjectStyle = {
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '80px',
    padding: '20px',
  },
  specificProjectsRow: {
    marginTop: '20px',
  },
  specificProjectCol: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '30px',
  },
  eachProjectContainer: {
    display: 'flex',
    width: '350px',
    height: '250px',
  },
  projectImageStyle: {
    width: '350px',
    height: '250px',
  },
  eachProjectDetailsContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    padding: 10,
  },
  eachProjectTitle: {
    display: 'flex',
    flex: 2,
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
    color: '#000000ba',
  },
  eachProjectToolsContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 8,
  },
  ReadmoreButtonDiv: {
    display: 'flex',
    flex: 2,
    justifyContent: 'center',
    alignItems: 'center',
  },
  readmoreButton: {
    backgroundColor: '#B5179E',
    color: 'white',
    fontWeight: 'bold',
    // cursor: 'pointer',
  },
  readmoreButtonActive: {
    backgroundColor: '#b5179da3',
    color: 'white',
    fontWeight: 'bold',
    // transition: '250ms 0ms all linear',
    // cursor: 'pointer',
  },
  eachProjectTool: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 5,
  },
  eachToolIcon: {
    width: 30,
    height: 30,
  },
  eachToolName: {
    marginLeft: 5,
    display: 'flex',
    color: '#000000ba',
  },
};

export const BlogStyle = {
  blogContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '80px',
    padding: '20px',
  },
  specificBlog: {
    marginTop: '20px',
  },
  eachBlogCol: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '30px',
  },
  eachBlogContainer: {
    // border: '1px solid black',
    width: '300px',
    cursor: 'pointer',
  },
  BlogImageStyle: {
    width: '300px',
    height: '150px',
  },
  blogTitle: {
    marginTop: '20px',
    color: '#000000ba',
  },
  blogTitleActive: {
    marginTop: '20px',
    color: '#4361EE',
  },
  blogTextDiv: {
    color: '#000000ba',
  },
  blogTextBorder: {
    border: '1px solid blue',
    width: '50px',
    marginTop: '20px',
  },
  blogText: {
    marginTop: '15px',
  },
};

export const HobbiesStyle = {
  hobbiesContainer: {
    width: '100%',
    paddingBottom: '50px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '80px',
    padding: '20px',
  },
  subTitleDiv: {
    marginTop: '20px',
    color: '#000000ba',
  },
  eachHobbyContainer: {
    marginTop: '40px',
  },
  eachHobbyCol: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  IconStyleDiv: {
    width: '100px',
    height: '100px',
  },
  eachHobbyNameDiv: {
    color: '#000000ba',
  },
};

export const ContactStyle = {
  contactContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '80px',
    padding: '20px',
  },
  contactIntroTxt: {
    marginTop: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#000000ba',
  },
  contactFormDiv: {
    marginTop: '40px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  eachInput: {
    // width: '400px',
    // height: '40px',
    marginTop: '5px',
    fontSize: '15px',
    color: '#F72585',
    border: '0px solid black',
    borderRadius: '10px',
  },
  eachInputMessage: {
    height: '150px',
  },
  inputErrorTxt: {
    color: 'red',
  },
  submitButtonDiv: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '10px',
  },
  submitButton: {
    color: 'white',
    backgroundColor: '#B5179E',
    cursor: 'pointer',
  },
  submitButtonActive: {
    color: 'white',
    backgroundColor: '#b5179da3',
    cursor: 'pointer',
  },
};

export const FooterStyle = {
  footerMainContainer: {
    width: '100%',
    backgroundColor: 'rgba(181, 23, 158, 1)',
  },
  footerContainer: {
    width: '100%',
    height: '200px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '80px',
    padding: '20px',
  },
  iconsDiv: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  iconsRow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  eachIconDiv: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '50px',
    height: '50px',
    border: '1px solid white',
    marginLeft: '10px',
    marginRight: '10px',
    marginTop: '10px',
    cursor: 'pointer',
  },
  eachIconDivActive: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '50px',
    height: '50px',
    backgroundColor: '#B5179E',
    marginLeft: '10px',
    marginRight: '10px',
    marginTop: '10px',
    cursor: 'pointer',
  },
  socialIcon: {
    color: 'white',
    fontSize: '25px',
  },
  socialIconActive: {
    color: 'white',
    fontSize: '25px',
  },
  copyRightTxtDiv: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    marginTop: '30px',
    color: 'white',
  },
};

export const ProjectModalStyle = {
  projectModalActive: {
    display: 'flex',
    position: 'fixed',
    top: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 3,
    justifyContent: 'center',
  },
  projectModalDeactive: {
    display: 'none',
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    // position: 'fixed',
    backgroundColor: 'white',
    height: '90%', // height is in percentage to ensure responsiveness
    width: '700px', // react-boostrap's container is responisive for width
    top: 0,
    marginLeft: '10px',
    marginRight: '10px',
  },
  modalCol: {
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'center',
    alignItems: 'center',
  },
  carouselStyle: {
    display: 'flex',
    width: '100%',
    height: '50%',
  },
  slideImageStyle: {
    width: '100%',
    height: '350px',
  },
  carouselControButton: {
    fontSize: '50px',
    color: 'white',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    padding: '10px',
  },
  projectDetailsCol: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
    // backgroundColor: 'pink',
    width: '100%',
    height: '50%',
  },
  projectDetailsNameAndMottoCol: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    // height: '20%',
    // backgroundColor: 'blue',
  },
  eachProjectDetailsNameCol: {
    display: 'flex',
    // alignItems: 'center',
    alignItems: 'flex-end',
    color: '#000000ba',
  },
  eachProjectDetailsMottoCol: {
    display: 'flex',
    alignItems: 'flex-start',
    color: '#48A9A6',
  },
  projectDetailsDescriptionCol: {
    display: 'flex',
    width: '100%',
    // height: '20%',
    // backgroundColor: 'green',
    alignItems: 'center',
    color: '#000000ba',
  },
  projectDetailsButtonsCol: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    // height: '10%',
    // backgroundColor: 'yellow',
  },
  projectButtons: {
    marginRight: '5px',
    marginLeft: '5px',
    backgroundColor: '#B5179E',
    color: 'white',
    fontWeight: 'bold',
  },
};
